import { render, staticRenderFns } from "./honorb.vue?vue&type=template&id=74db2e78&scoped=true"
import script from "./honorb.vue?vue&type=script&lang=js"
export * from "./honorb.vue?vue&type=script&lang=js"
import style0 from "./honorb.vue?vue&type=style&index=0&id=74db2e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db2e78",
  null
  
)

export default component.exports